export function buildPortfolioScenariosPageQueryV1(workspaceId: number, tchProjectId: number)
{
	return {
		'$type': 'TCh.Domain.Quest.PortfolioScenarios.Queries.PortfolioScenariosPageQueryV1, TCh.Domain.Quest',
		'WorkspaceId': workspaceId,
		'TchProjectId': tchProjectId,
	}
}

export function buildProjectsPageQueryV1(workspaceId: number, tchProjectId: number, scenarioId: string)
{
	return {
		'$type': 'TCh.Domain.Quest.PortfolioScenarios.Queries.ProjectsPageQueryV1, TCh.Domain.Quest',
		'WorkspaceId': workspaceId,
		'TchProjectId': tchProjectId,
		'ScenarioId': scenarioId
	}
}

export function buildScenarioProjectPlanPickerQueryV1(workspaceId: number, tchProjectId: number, scenarioId: string, projectId: string)
{
	return {
		'$type': 'TCh.Domain.Quest.PortfolioScenarios.Queries.ScenarioProjectPlanPickerQueryV1, TCh.Domain.Quest',
		'WorkspaceId': workspaceId,
		'TchProjectId': tchProjectId,
		'ScenarioId': scenarioId,
		'ProjectId': projectId
	}
}

export function buildSelectionPageQueryV1(workspaceId: number, tchProjectId: number, scenarioId: string)
{
	return {
		'$type': 'TCh.Domain.Quest.PortfolioScenarios.Queries.SelectionPageQueryV1, TCh.Domain.Quest',
		'WorkspaceId': workspaceId,
		'TchProjectId': tchProjectId,
		'ScenarioId': scenarioId
	}
}




export function buildApprovalPageQueryV1(workspaceId: number, tchProjectId: number, scenarioId: string)
{
	return {
		'$type': 'TCh.Domain.Quest.PortfolioScenarios.Queries.ApprovalPageQueryV1, TCh.Domain.Quest',
		'WorkspaceId': workspaceId,
		'TchProjectId': tchProjectId,
		'ScenarioId': scenarioId
	}
}

export function buildReviewPageQueryV1(workspaceId: number, tchProjectId: number, scenarioId: string)
{
	return {
		'$type': 'TCh.Domain.Quest.PortfolioScenarios.Queries.ReviewPageQueryV1, TCh.Domain.Quest',
		'WorkspaceId': workspaceId,
		'TchProjectId': tchProjectId,
		'ScenarioId': scenarioId
	}
}


export function buildCriteriaPageQueryV1(workspaceId: number, tchProjectId: number, scenarioId: string)
{
	return {
		'$type': 'TCh.Domain.Quest.PortfolioScenarios.Queries.CriteriaPageQueryV1, TCh.Domain.Quest',
		'WorkspaceId': workspaceId,
		'TchProjectId': tchProjectId,
		'ScenarioId': scenarioId
	}
}


export function buildNewScenarioSettingsQueryV1(workspaceId: number, portfolioId: string, corporateScenarioId: string)
{
	return {
		'$type': 'TCh.Domain.Quest.PortfolioScenarios.Queries.NewScenarioSettingsQueryV1, TCh.Domain.Quest',
		'WorkspaceId': workspaceId,
		'PortfolioId': portfolioId,
		'CorporateScenarioId': corporateScenarioId,
	}
}

export function buildExistingScenarioSettingsQueryV1(workspaceId: number, portfolioId: string, portfolioScenarioId: string)
{
	return {
		'$type': 'TCh.Domain.Quest.PortfolioScenarios.Queries.ExistingScenarioSettingsQueryV1, TCh.Domain.Quest',
		'WorkspaceId': workspaceId,
		'PortfolioId': portfolioId,
		'PortfolioScenarioId': portfolioScenarioId,
	}
}


export function buildSchedulingPageQueryV1(workspaceId: number, tchProjectId: number, scenarioId: string)
{
	return {
		'$type': 'TCh.Domain.Quest.PortfolioScenarios.Queries.SchedulingPageQueryV1, TCh.Domain.Quest',
		'WorkspaceId': workspaceId,
		'TchProjectId': tchProjectId,
		'ScenarioId': scenarioId
	}
}

export function buildPnlPageQueryV1(workspaceId: number, tchProjectId: number, scenarioId: string)
{
	return {
		'$type': 'TCh.Domain.Quest.PortfolioScenarios.Queries.PnlPageQueryV1, TCh.Domain.Quest',
		'WorkspaceId': workspaceId,
		'TchProjectId': tchProjectId,
		'ScenarioId': scenarioId,
	}
}

export function buildPortfolioScenarioPnlQueryV1(workspaceId: number, tchProjectId: number, scenarioId: string, applyBenefitsConfidenceFactor: boolean, pnlTemplateId: string, denomination: string)
{
	return {
		'$type': 'TCh.Domain.Quest.PortfolioScenarios.Queries.PortfolioScenarioPnlQueryV1, TCh.Domain.Quest',
		'WorkspaceId': workspaceId,
		'TchProjectId': tchProjectId,
		'ScenarioId': scenarioId,
		'ApplyBenefitsConfidenceFactor': applyBenefitsConfidenceFactor,
		'PnlTemplateId': pnlTemplateId,
		'Denomination': denomination
	}
}


export function buildResourceConstraintPageQueryV1(workspaceId: number, tchProjectId: number, scenarioId: string, resourceId: string)
{
	return {
		'$type': 'TCh.Domain.Quest.PortfolioScenarios.Queries.ResourceConstraintPageQueryV1, TCh.Domain.Quest',
		'WorkspaceId': workspaceId,
		'TchProjectId': tchProjectId,
		'ScenarioId': scenarioId,
		'ResourceId': resourceId,
	}
}

export function buildSelectorSettingsQueryV1(workspaceId: number, portfolioId: string, scenarioId: string)
{
	return {
		'$type': 'TCh.Domain.Quest.PortfolioScenarios.Queries.SelectorSettingsQueryV1, TCh.Domain.Quest',
		'WorkspaceId': workspaceId,
		'PortfolioId': portfolioId,
		'ScenarioId': scenarioId
	}
}




